import React, { useEffect, useRef, useState } from 'react';
import { Button, Input } from 'barte-design-system';
import { UI_ATTR } from './anchor';
import { DraftAnchor } from './types';

interface Props {
  draft: DraftAnchor;
  author: string | null;
  onSubmit: (body: string, author: string) => void;
  onCancel: () => void;
}

export function Composer({ draft, author, onSubmit, onCancel }: Props) {
  const [body, setBody] = useState('');
  const [name, setName] = useState(author || '');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current?.querySelector('textarea, input');
    if (el) (el as HTMLElement).focus();
  }, []);

  const pos = clampToViewport(draft.viewportX, draft.viewportY);
  const canSubmit = body.trim().length > 0 && name.trim().length > 0;

  const submit = () => {
    if (canSubmit) onSubmit(body.trim(), name.trim());
  };

  return (
    <div
      ref={ref}
      className="bc-popover"
      {...{ [UI_ATTR]: '' }}
      style={{ left: pos.left, top: pos.top }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit();
      }}
    >
      <div className="bc-popover__head">
        <span className="bc-popover__title">Novo comentário</span>
      </div>
      <div className="bc-popover__body">
        {!author && (
          <Input
            label="Seu nome"
            placeholder="Como você aparece no time"
            value={name}
            onChange={(e) => setName((e.target as HTMLInputElement).value)}
          />
        )}
        <Input
          type="textarea"
          label={author ? undefined : 'Comentário'}
          placeholder="Escreva um comentário…"
          value={body}
          rows={3}
          onChange={(e) => setBody((e.target as HTMLTextAreaElement).value)}
        />
      </div>
      <div className="bc-popover__foot">
        <div className="bc-row">
          <span className="bc-spacer" />
          <Button variant="ghost" size="sm" onClick={onCancel}>
            Cancelar
          </Button>
          <Button variant="fill" size="sm" onClick={submit} disabled={!canSubmit}>
            Comentar
          </Button>
        </div>
      </div>
    </div>
  );
}

function clampToViewport(x: number, y: number): { left: number; top: number } {
  const W = 320;
  const H = 260;
  const left = Math.max(12, Math.min(x + 14, window.innerWidth - W - 12));
  const top = Math.max(12, Math.min(y + 14, window.innerHeight - H - 12));
  return { left, top };
}
